export default __webpack_public_path__ + "f913f8694367eb5650c216e7d97cc4c8.svg";